import React, {useRef, useState} from 'react';
import classNames from 'classnames';
import {useDisclosure} from 'hooks/useDisclosure';

import DateRangeComponentV2 from '../DateRangeV2/DateRangeComponentV2';
import {DateRange, DisabledDays, PresetOption} from '../DateRangeV2/types';
import {DropdownContainer} from '../Form/Select/DetachedSearchSelect/DropdownContainer';

import {ButtonDropdown} from './ButtonDropdown';
import {dropdownStyle} from './dropdown-style';

interface ComboBoxDateRangeProps {
  label: string;
  placeholder?: string;
  onChange: (range: DateRange) => void;
  initialRange?: DateRange;
  initialPreset?: PresetOption;
  className?: string;
  disabledDays?: DisabledDays[];
}

function formatDateRange(range: DateRange, placeholder: string) {
  if (!range.startDate || !range.endDate) return placeholder;
  // Format as MM/DD/YYYY - MM/DD/YYYY
  const start = range.startDate.toLocaleDateString();
  const end = range.endDate.toLocaleDateString();
  return `${start} - ${end}`;
}

const ComboBoxDateRange: React.FC<ComboBoxDateRangeProps> = ({
  label,
  placeholder = 'Select a date range',
  onChange,
  initialRange,
  initialPreset = 'custom',
  className,
  disabledDays,
}) => {
  const {isOpen, close, toggle} = useDisclosure();
  const outerRef = useRef<HTMLDivElement>(null);
  const [selectedRange, setSelectedRange] = useState<DateRange>(
    initialRange || {startDate: null, endDate: null},
  );

  const handleRangeChange = (range: DateRange) => {
    setSelectedRange(range);
    close();
    onChange(range);
  };

  return (
    <div
      className={classNames('relative h-auto isolate w-full ', className)}
      ref={outerRef}
    >
      <DropdownContainer
        isOpen={isOpen}
        onClose={close}
        target={
          <ButtonDropdown
            onClick={toggle}
            label={label}
            selectedOutput={formatDateRange(selectedRange, placeholder)}
            isOpen={isOpen}
          />
        }
        styles={{
          dropdownMenu: () => ({...dropdownStyle, position: 'fixed'}),
        }}
      >
        <div className="z-10 bg-white rounded-2xl shadow-md flex flex-col cursor-pointer">
          <DateRangeComponentV2
            onChange={handleRangeChange}
            initialRange={selectedRange}
            initialPreset={initialPreset}
            disabledDays={disabledDays}
          />
        </div>
      </DropdownContainer>
    </div>
  );
};

export default ComboBoxDateRange;
